import { FormOfAddresses } from "@/components/Onboarding/Steps/PersonalDetails/PersonalDetailsFormFields/PersonalDetailsFormFields";
import {
  SalesPartnerCreateCustomerLanguageEnum,
  SalesPartnerCreateCustomerSalutationEnum,
} from "@/services/model";
import type { HeaderModel } from "@/services/model/headerModel";
import type { PrepareBasketRequest } from "@/services/model/prepareBasketRequest";
import type { PrepareBasketRequestDevice } from "@/services/model/prepareBasketRequestDevice";
import type { PrepareBasketRequestSimType } from "@/services/model/prepareBasketRequestSimType";
import type { SalesPartnerCreateCustomer } from "@/services/model/salesPartnerCreateCustomer";
import { env } from "@/utils/environmentHelpers";

import type { TestWebshopFormType } from "./testWebshopTypes";

export const transformFormDataToPrepareBasketRequest = (
  formData: TestWebshopFormType,
  header: HeaderModel,
): PrepareBasketRequest => {
  let customer: SalesPartnerCreateCustomer | undefined;

  if (!formData.isExistingCustomer && formData.customer) {
    customer = {
      firstName: formData.customer.firstName,
      lastName: formData.customer.lastName,
      contactPhoneNumber: formData.customer.contactPhoneNumber,
      city: formData.customer.city,
      countryCodeAlpha2: formData.customer.countryCodeAlpha2.ALPHA2,
      houseNumber: formData.customer.houseNumber,
      street: formData.customer.street,
      zip: formData.customer.zip,
      languageEnum: formData.customer
        .languageEnum as SalesPartnerCreateCustomerLanguageEnum,
      salutationEnum:
        formData.customer.salutationEnum === FormOfAddresses.other.toString()
          ? SalesPartnerCreateCustomerSalutationEnum.MX
          : formData.customer.salutationEnum === FormOfAddresses.mr.toString()
            ? SalesPartnerCreateCustomerSalutationEnum.MR
            : SalesPartnerCreateCustomerSalutationEnum.MS,
      birthday: formData.customer.birthday,
      header,
    };
  }

  const request: PrepareBasketRequest = {
    header,
    partnerId: env.clientNumericId,
    mail: formData.mail,
    onp: formData.onp === "true",
    productId: formData.productId,
    simAlias: formData.simAlias,
  };

  if (customer) {
    request.customer = customer;
  }

  if (formData.device) {
    request.device = formData.device as PrepareBasketRequestDevice;
  }

  if (formData.simType) {
    request.simType = formData.simType as PrepareBasketRequestSimType;
  }

  // prepareBasket (webshop): OpenAPI marks iccid/puk as optional; do not send them.

  return request;
};
